module.exports = __webpack_public_path__ + "img/banner_kook.3aefbbb.png";